module.exports = __webpack_public_path__ + "img/pangao_pic2.497b7235.png";